import { AgingTransDocument } from '@dato-proxy/entities/agingtransdocument.entity';
import { BaseGridDocumentComponent } from '@dato-pages/base/base-grid-document-component';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { Component, Input } from '@angular/core';

@Component({
    providers: ServiceBagServices,
    selector: 'app-aging-report-grid',
    templateUrl: './aging-report-grid.component.html',
    styleUrls: ['./aging-report-grid.component.scss']
})
export class AgingReportGridComponent extends BaseGridDocumentComponent<AgingTransDocument> {
    @Input() public IsOpen: boolean;
    @Input() public Currency: string;

    constructor(A: ServiceBagService) {
        super(A, 'AgingReportGridComponent', AgingTransDocument);
    }

    calculateCustomSummary = (options) => {
        const item: AgingTransDocument = options.value;

        if (item) {
            if (options.name === 'Sum') { this.calculate(options, this.IsOpen ? item.OpenSum : item.TotalSum); }
            if (options.name === 'SumFeature') { this.calculate(options, this.IsOpen ? item.OpenSumFeature : item.TotalSumFeature); }
            if (options.name === 'Sum1_30') { this.calculate(options, this.IsOpen ? item.OpenSum1_30 : item.TotalSum1_30); }
            if (options.name === 'Sum31_60') { this.calculate(options, this.IsOpen ? item.OpenSum31_60 : item.TotalSum31_60); }
            if (options.name === 'Sum61_90') { this.calculate(options, this.IsOpen ? item.OpenSum61_90 : item.TotalSum61_90); }
            if (options.name === 'Sum90_180') { this.calculate(options, this.IsOpen ? item.OpenSum90_180 : item.TotalSum90_180); }
            if (options.name === 'Sum180Plus') { this.calculate(options, this.IsOpen ? item.OpenSum180Plus : item.TotalSum180Plus); }
        }
    }

    calculate(options: any, value: number) {
        if (!options.totalValue) { options.totalValue = 0; }
        if (value) { options.totalValue += value; }
    }
}
